import * as React from 'react';
import { styled, alpha, useTheme } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import { Autocomplete, TextField } from '@mui/material';
import { searchableFeatures } from '../model/pageList';

const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginRight: theme.spacing(2),
  marginLeft: theme.spacing(3),
  flexGrow: 1,
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

interface PrimarySearchAppBarProps {
  toggleDrawer: () => void;
  setCurrentView: (view: string) => void;
  searchText: string;
  setSearchText: (text: string) => void;
}

export default function SearchAppBar(props: PrimarySearchAppBarProps) {
  const theme = useTheme();

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        position='fixed'
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
      >
        <Toolbar>
          <IconButton
            size='large'
            edge='start'
            color='inherit'
            aria-label='open drawer'
            onClick={props.toggleDrawer}
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton>
          <Box
            component="img"
            src="/techlead.png"
            alt="TL Utility Logo"
            sx={{
              height: 32,
              width: 32,
              mr: 2,
              display: { xs: 'none', sm: 'block' }
            }}
          />
          <Typography
            variant='h6'
            noWrap
            component='div'
            sx={{ display: { xs: 'none', sm: 'block' } }}
            onClick={() => props.setCurrentView('')}
          >
            TL Utility
          </Typography>
          <Search>
            <SearchIconWrapper>
              <SearchIcon />
            </SearchIconWrapper>
            <Autocomplete
              freeSolo
              value={props.searchText}
              onChange={(event, newValue) => {
                props.setSearchText(newValue || '');
                const selectedFeature = searchableFeatures.find(feature => feature.label === newValue);
                if (selectedFeature) {
                    props.setCurrentView(selectedFeature.path);
                }
              }}
              options={searchableFeatures.map((option) => option.label)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder='Search…'
                  variant='outlined'
                  fullWidth
                  InputProps={{
                    ...params.InputProps,
                    startAdornment: <>{params.InputProps.startAdornment}</>,
                    style: { paddingLeft: `calc(1em + ${theme.spacing(4)})` },
                  }}
                />
              )}
            />
          </Search>
          <Box sx={{ flexGrow: 1 }} />
        </Toolbar>
      </AppBar>
    </Box>
  );
}
